(function(){
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.documentElement.classList.add('fa-js');

    var reveal=document.querySelectorAll('[data-fa-reveal]');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('fa-visible');io.unobserve(entry.target)}})},{threshold:.12});
      reveal.forEach(function(el,i){el.style.transitionDelay=Math.min(i%8,5)*55+'ms';io.observe(el)});
    }else{reveal.forEach(function(el){el.classList.add('fa-visible')})}

    var finePointer=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(finePointer){
      document.querySelectorAll('.fa-magnetic').forEach(function(el){
        el.addEventListener('mousemove',function(e){
          var r=el.getBoundingClientRect(), x=e.clientX-r.left-r.width/2, y=e.clientY-r.top-r.height/2;
          el.style.transform='translate('+x*.13+'px,'+y*.18+'px) translateY(-4px)';
        });
        el.addEventListener('mouseleave',function(){el.style.transform='translate(0,0)'});
      });

      document.querySelectorAll('.fa-tilt-card').forEach(function(card){
        card.addEventListener('mousemove',function(e){
          var r=card.getBoundingClientRect(), px=(e.clientX-r.left)/r.width-.5, py=(e.clientY-r.top)/r.height-.5;
          card.style.transform='perspective(900px) rotateX('+(-py*6)+'deg) rotateY('+(px*7)+'deg) translateY(-8px)';
        });
        card.addEventListener('mouseleave',function(){card.style.transform='perspective(900px) rotateX(0) rotateY(0) translateY(0)'});
      });
    }

    document.querySelectorAll('a,button').forEach(function(el){
      el.addEventListener('pointerdown',function(){ if(el.classList.contains('fa-magnetic')||el.classList.contains('fa-icon-btn')) el.style.scale='.97'; });
      el.addEventListener('pointerup',function(){el.style.scale='';});
      el.addEventListener('pointercancel',function(){el.style.scale='';});
    });

    var header=document.querySelector('.fa-header__inner');
    if(header){
      var last=0;
      window.addEventListener('scroll',function(){
        var y=window.scrollY||0;
        header.style.boxShadow=y>20?'0 18px 55px rgba(84,43,68,.14)':'0 10px 40px rgba(84,43,68,.09)';
        last=y;
      },{passive:true});
    }
  });
})();
